import { DisplayState } from '../types/display-state.enum';
import { ComponentView } from '../types/system-health.types';

/**
 * A confirmed outage anywhere in the row: the dependency itself, or one reporting
 * service's own instance of it.
 *
 * @param component - Row to test.
 * @returns True when something in the row is confirmed down.
 */
export function isUnavailable(component: ComponentView): boolean {
  return (
    component.state === DisplayState.Unavailable ||
    component.affectedServices.some(service => service.state === DisplayState.Unavailable)
  );
}

/**
 * The single definition of "worth listing". The banner and the issues list both
 * read it, so the page cannot say "all systems available" above a card.
 *
 * @param component - Row to test.
 * @returns True when the row belongs in the issues list.
 */
export function isIssue(component: ComponentView): boolean {
  return component.state !== DisplayState.Available || isUnavailable(component);
}
